import React from 'react';

interface WithoutCustomSize {
  size: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  customSize?: never;
  orientation: 'vertical' | 'horizontal';
}

interface WithCustomSize {
  customSize: number;
  size?: never;
  orientation: 'vertical' | 'horizontal';
}

const sizeDictionary = {
  xsmall: 4,
  small: 8,
  medium: 16,
  large: 32,
  xlarge: 64,
};
/* 
    This component display space according to the size and orientation.
 */
export function Spacer({
  orientation,
  size = 'xsmall',
  customSize,
}: WithoutCustomSize | WithCustomSize): React.ReactElement | null {
  return (
    <div
      style={{
        display: orientation === 'horizontal' ? 'inline' : 'block',
        padding:
          orientation === 'horizontal'
            ? `0px ${customSize ?? sizeDictionary[size]}px`
            : `${customSize ?? sizeDictionary[size]}px 0px`,
      }}
    />
  );
}
